export default __webpack_public_path__ + "static/media/red4.7c50c540.jpg";